'use client';

import { Fragment, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import useHeaderStore from '@/store/header';

import { useHomepageStructure } from '../hooks/homepage';
import { IconArrowDown } from '@/icons/IconArrowDown';

import Divider from './Divider';
import LocationModal from './LocationModal';
import { useDeliveryOption } from '@/hooks/useDeliveryOptions';
import { IArea, IStoreLists } from '@/interfaces/location';

export function PreHeaderStoreSelector() {
  const pathname = usePathname();

  const { data: homePageStructure } = useHomepageStructure();
  const [showLocationModal, setShowLocationModal] = useState<boolean>(false);
  const setShowPickInStoreOption = useHeaderStore((state) => state.setShowPickInStoreOption);
  const setShowExpressOption = useHeaderStore((state) => state.setShowExpressOption);
  const setShowCorporateDiscountOption = useHeaderStore((state) => state.setShowCorporateDiscountOption);
  const setExpressMessage = useHeaderStore((state) => state.setExpressMessage);
  const setSelectedStoreIds = useHeaderStore((state) => state.setSelectedStoreIds);
  const setSelectedStoreCodes = useHeaderStore((state) => state.setSelectedStoreCodes);
  const setIsExpressEnabled = useHeaderStore((state) => state.setIsExpressEnabled);
  const setSelectedStore = useHeaderStore((state) => state.setSelectedStore);
  const setMyLocation = useHeaderStore((state) => state.setMyLocation);
  const { selectedStore } = useDeliveryOption();

  useEffect(() => {
    if (homePageStructure) {
      setShowPickInStoreOption(homePageStructure?.IsBopisFeatureActive);
      setShowCorporateDiscountOption(homePageStructure?.IsCorporateUser || false)
      setShowExpressOption(homePageStructure?.ExpressDelivery?.IsExpressDeliveryActive);
      setExpressMessage(homePageStructure?.ExpressDelivery?.Message || '');
      if (homePageStructure?.ExpressDelivery?.IsExpressDeliveryActive === false) {
        setSelectedStoreIds([]);
        setSelectedStoreCodes([]);
        setIsExpressEnabled(false);
        setMyLocation({} as IArea);
      }
      if (homePageStructure?.IsBopisFeatureActive === false) {
        setSelectedStore({} as IStoreLists);
      }
    }
  }, [homePageStructure]);

  if (homePageStructure?.IsBopisFeatureActive && (pathname === '/' || pathname.includes('/product'))) {
    return (
      <>
        <div className="flex items-center space-x-2">
          <p className="text-base font-normal text-[#818181]">Pick From Store: </p>
          <div
            onClick={() => {
              setShowLocationModal(true);
            }}
            className="flex cursor-pointer items-center space-x-2 hover:underline"
          >
            <p className="text-base font-semibold text-black">{selectedStore?.Name ? selectedStore?.Name : 'Select Store'}</p>
            <IconArrowDown className="mt-[1px] h-4 w-4" />
          </div>
        </div>
        <Divider className="mx-4" vertical />
        <LocationModal showLocationModal={showLocationModal} setShowLocationModal={setShowLocationModal} isBopis={true} />
      </>
    );
  }
  return <Fragment />;
}
